import { ServiceRequestRepository } from './ServiceRequestValuesToCompensateRepository'
import ServiceRequestModel from '../../../../ServiceRequestModel'
import { JtechStore } from 'src/plugins/mobx'
import router from 'src/router'

export default class ServiceRequestValuesToCompensateController {
  state = ServiceRequestModel.getInstance();

  static getInstance () {
    return JtechStore.getSingleton('ServiceRequestValuesToCompensateController', new ServiceRequestValuesToCompensateController())
  }

  async loadValuesToCompensateForm () {
    return await ServiceRequestRepository.loadValuesToCompensateForm()
  }
}
